import * as service from "../service";
import { store } from "../../store";
import type { ServiceResponse } from "../types";

export type ApproveMembershipParams = {
  membership_id: string;
  approved: boolean;
  reject_reason?: string;
  user_id?: string;
};

export type ApproveMembershipResult = Record<string, any>;

/**
 * Approve or reject a society membership request.
 * Backend: POST /api/society/approveMembership
 */
export const ApproveMembershipAPI = async (
  params: ApproveMembershipParams,
): Promise<ServiceResponse<ApproveMembershipResult>> => {
  const { student, admin } = store.getState().auth;
  const user_id = params.user_id || student.id || admin.id;
  try {
    const resp = (await service.call(
      "POST",
      "/api/society/approveMembership",
      { ...params, user_id },
    )) as ServiceResponse<ApproveMembershipResult>;
    return resp;
  } catch (err) {
    console.error(`ApproveMembershipAPI ${err}`);
    return { status: -1, error: err };
  }
};